define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseDropdownViewController = require('web-agent-components/BaseDropdownViewController');

    var ButtonDropdownViewController = BaseDropdownViewController.extend({
        ControllerName: "ButtonDropdownViewController",

        LPViewMap: {
            selectedView: ".lpview_selected_value"
        },

        initialize: function (constructorData) {
            this.itemClickedCallback = constructorData.itemClicked;
            this.context = constructorData.context;
            this.buttonTitleEnabled = constructorData.buttonTitleEnabled || false;
        },

        events: function () {
        },

        render: function () {
            this.setButtonText();
        }
    });

    ButtonDropdownViewController.prototype.getConfiguration = function () {
        var configuration = {
            templateFile: "LP_button_dropdown.html",
            rowTemplateFile: "LP_form_dropdown_row.html",
            focusedViewClass: this.LPViewMap.focusElement
        };
        return configuration;
    };

    ButtonDropdownViewController.prototype.onItemClicked = function (data) {
        BaseDropdownViewController.prototype.onItemClicked.call(this, data);
        if (!this.enabled) {
            return;
        }
        if (!data.rowData.disabled) {
            this.setButtonText();
            this.collapseItems();
            this.callItemClickedCallback(data);
        }
    };

    ButtonDropdownViewController.prototype.onFocusedViewClicked = function (e) {
        BaseDropdownViewController.prototype.onFocusedViewClicked.call(this, e);
        if (this.itemsDisplayed) {
            this.collapseItems();
        } else {
            this.expandItems();
        }
    };

    ButtonDropdownViewController.prototype.setSelectedIndex = function (index) {
        BaseDropdownViewController.prototype.setSelectedIndex.call(this, index);
        this.setButtonText();
        this.collapseItems();
    };

    ButtonDropdownViewController.prototype.setButtonText = function () {
        if (typeof this.selectedIndex === "undefined") {
            this.getFirstElement(this.LPViewMap.selectedView).innerHTML = this.titleText;
            if (this.buttonTitleEnabled) {
                this.getFirstElement(this.LPViewMap.selectedView).removeAttribute('title');
            }
        }
        else if (this.selectedIndex >= 0) {
            var buttonText = this.items[this.selectedIndex][this.textProperty];
            this.getFirstElement(this.LPViewMap.selectedView).innerHTML = lpUtils.escapeHTML(buttonText);
            if (this.buttonTitleEnabled) {
                this.getFirstElement(this.LPViewMap.selectedView).setAttribute('title', buttonText);
            }
        }
    };

    ButtonDropdownViewController.prototype.callItemClickedCallback = function (data) {
        if (this.itemClickedCallback) {
            this.itemClickedCallback.call(this.context, data, this);
        }
    };

    ButtonDropdownViewController.prototype.reset = function () {
        this.setSelectedIndex(this.defaultIndex);
    };

    return ButtonDropdownViewController;

});
